import { createSlice } from "@reduxjs/toolkit";

/**
 * webtopUi — ephemeral (non-persisted) UI state for the Webtop shell. Lets
 * different parts of the shell (desktop icon, Start menu, desktop right-click)
 * open the same built-in apps without prop-drilling. Currently: the Sticky
 * Notes app.
 */
const webtopUiSlice = createSlice({
  name: "webtopUi",
  initialState: {
    notesAppOpen: false,
    // File clipboard for copy/cut/paste: { id, mode: 'copy'|'cut', scope, name, type } | null
    clipboard: null,
  },
  reducers: {
    openNotesApp: (state) => {
      state.notesAppOpen = true;
    },
    closeNotesApp: (state) => {
      state.notesAppOpen = false;
    },
    setClipboard: (state, action) => {
      state.clipboard = action.payload || null;
    },
    clearClipboard: (state) => {
      state.clipboard = null;
    },
  },
});

export const { openNotesApp, closeNotesApp, setClipboard, clearClipboard } = webtopUiSlice.actions;
export default webtopUiSlice.reducer;
